import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';

declare const $localize: (messageParts: TemplateStringsArray, ...expressions: any[]) => string;

@Component({
  selector: 'app-einvoice-pdf-view',
  templateUrl: './pdf-view.component.html',
  styleUrls: ['./pdf-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EinvoicePdfViewComponent implements OnChanges {
  @Input() pdfBytes: Uint8Array | undefined;
  @Input() pdfFileName = 'document.pdf';

  loading = false;
  errorMessage = '';
  viewerPdfBytes: Uint8Array | undefined;
  readonly pdfJsOptions = { enableScripting: false };

  private readonly cdr = inject(ChangeDetectorRef);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pdfBytes']) {
      this.errorMessage = '';
      this.viewerPdfBytes = this.pdfBytes?.slice();
      this.loading = this.viewerPdfBytes !== undefined && this.viewerPdfBytes.byteLength > 0;
      this.cdr.markForCheck();
    }
  }

  onDocumentLoad(): void {
    this.loading = false;
    this.cdr.markForCheck();
  }

  onDocumentError(): void {
    this.loading = false;
    this.errorMessage = $localize`:@@einvoice.pdf-view.load-error:Could not load source PDF preview.`;
    this.cdr.markForCheck();
  }
}